export const cookietypes = {
    authCookie : 'auth-data-design-dlr'
}
